import React from 'react';
import { EditButton, Show, SimpleShowLayout, TextField } from 'react-admin';
import { Link } from 'react-router-dom'
import { CampaignPerformanceDetail } from './CampaignPerformanceDetail';
import { ProfileInsightDetail } from './ProfileInsightDetail';
import { JourneyInsightDetail } from './JourneyInsightDetail';
import OptimizationAnalyzer from './OptimizationAnalyzer';
import OptimizationFullView from './OptimizationFullView';
import PageDetailInsights from './PageDetailInsights';
import PersonalizationAction from './PersonalizationAction';

export const InsightDetailRouter = (props) => (
    <Show title={<TextField source="title" />} actions={null} {...props}>
        <SimpleShowLayout>
            <DetailSwitcher {...props} />
        </SimpleShowLayout>
    </Show>
);

const DetailSwitcher = (props) => {
    if (props.record.type === "JourneyInsight") {
        return <JourneyInsightDetail data={props.record} />
    }
    else if (props.record.type === "OptimizationInsight") {
        //return <OptimizationAnalyzer data={props.record} />
        return <OptimizationFullView data={props.record} />
    }
    else if (props.record.type === "PageDetailInsights") {
        return <PageDetailInsights data={props.record} />
    }
    else {
        switch (props.record.id) {
            case "top-campaign-performance":
                return <CampaignPerformanceDetail data={props.record} />
            case "key-profiles":
                return <ProfileInsightDetail data={props.record} />
            case "journeys-insight":
                return <JourneyInsightDetail data={props.record} />
            default:
                <h1>No chart found</h1>
        }
    }

    return <h1>No chart found</h1>;

}

export default InsightDetailRouter;


// WEBPACK FOOTER //
// ./src/pages/details/InsightDetailRouter.js